export default __webpack_public_path__ + "static/media/lieferheld_background_l1.f2748a9e.jpg";